/* ============================================================
   TECNOBOX theme.js — behaviors only (markup comes from Liquid)
   ============================================================ */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Cajones laterales ----------
     Un solo mecanismo para los dos: el de categorías del encabezado y el de
     categorías+filtros del catálogo. Antes esto eran cuatro IDs fijos
     (#drawer, #scrim, #burger, #dclose) y el segundo cajón habría obligado a
     copiar el bloque entero con otros cuatro.

     El contrato es por atributo: `data-drawer-open="<id>"` abre, y cualquier
     `data-drawer-close` dentro del panel lo cierra. El velo (#scrim) es uno
     solo y lo comparten, porque nunca hay dos cajones abiertos a la vez. */
  var scrim = document.getElementById('scrim');
  var abierto = null;

  /* `data-drawer="modal"` = cajón siempre y en toda pantalla (el de categorías
     del encabezado): cerrado hay que esconderlo del lector de pantalla.
     `data-drawer="responsive"` = en escritorio NO es cajón sino un rail a la
     vista (el de catálogo), así que marcarlo oculto lo borraría de la página
     para quien navega con lector. */
  function esModal(p){ return p.getAttribute('data-drawer') === 'modal'; }

  function cerrarCajon(){
    if(!abierto) return;
    abierto.classList.remove('on');
    if(esModal(abierto)) abierto.setAttribute('aria-hidden','true');
    if(scrim) scrim.classList.remove('on');
    document.body.style.overflow='';
    abierto = null;
  }
  function abrirCajon(panel){
    if(!panel) return;
    cerrarCajon();
    panel.classList.add('on');
    panel.removeAttribute('aria-hidden');
    if(scrim) scrim.classList.add('on');
    /* Bloquear el scroll del fondo: sin esto el dedo arrastra el catálogo por
       debajo del cajón y al cerrarlo uno quedó en otra parte de la página. */
    document.body.style.overflow='hidden';
    abierto = panel;
  }

  document.addEventListener('click',function(e){
    var btn = e.target.closest('[data-drawer-open]');
    if(btn){ e.preventDefault(); abrirCajon(document.getElementById(btn.getAttribute('data-drawer-open'))); return; }
    if(e.target.closest('[data-drawer-close]')){ e.preventDefault(); cerrarCajon(); return; }
    /* Un enlace dentro de un cajón navega igual: dejarlo abierto solo hace que
       la página nueva aparezca tapada por un panel que ya no viene al caso. */
    /* Quitar un producto usa un enlace como respaldo sin JavaScript. No es
       navegación cuando el drawer está activo: el manejador AJAX de carrito lo
       actualiza en su lugar, por lo que debe permanecer abierto. */
    if(abierto && e.target.closest('a') && abierto.contains(e.target) && !e.target.closest('[data-cd-remove]')){ cerrarCajon(); }
  });
  if(scrim) scrim.addEventListener('click',cerrarCajon);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') cerrarCajon(); });

  /* ---------- Filtros de catálogo ----------
     En ESCRITORIO el formulario se envía solo al marcar una casilla: el rail
     está a la vista, la grilla se actualiza al lado y un botón "Aplicar"
     agregaría un paso a algo que el usuario ya decidió al hacer clic.

     En MÓVIL no: ahí los filtros viven dentro de un cajón, y auto-enviar
     recargaría la página —y cerraría el cajón— en cada casilla. Marcar tres
     cosas serían tres recargas y tres reaperturas. Se juntan las marcas y las
     aplica el botón del pie ("Ver N productos").

     `change` y no `input` en los números: con `input` se enviaría el formulario
     a cada tecla y "12000" dispararía cinco recargas.

     Sin JS el <noscript> del snippet repone un botón "Aplicar filtros". */
  var esMovil = window.matchMedia('(max-width:900px)');
  document.querySelectorAll('[data-autofilter]').forEach(function(form){
    form.addEventListener('change', function(){ if(!esMovil.matches){ form.submit(); } });
  });

  /* El botón del pie del cajón aplica lo marcado. Si la tienda no tiene filtros
     configurados, el cajón es solo categorías y el botón nada más lo cierra. */
  document.querySelectorAll('[data-drawer-apply]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = btn.closest('[data-drawer]') || document;
      var form  = panel && panel.querySelector('[data-autofilter]');
      if(form){ form.submit(); } else { cerrarCajon(); }
    });
  });

  /* ---------- Hero carousel: pista deslizante ----------
     La pista (.ctrack) lleva todas las slides en fila y se mueve en bloque, así
     la que sale y la que entra viajan pegadas y nunca se ve el fondo entre las
     dos (que es lo que pasaba cruzándolas por opacidad).

     Para que el salto del último al primero no rebobine la fila entera, hay un
     CLON del primero al final y un CLON del último al principio. Se avanza sobre
     el clon con animación y, apenas termina, se reposiciona en el original SIN
     animación: el ojo no lo nota porque las dos imágenes son la misma. */
  document.querySelectorAll('[data-carousel]').forEach(function(root){
    var track  = root.querySelector('.ctrack');
    var dots   = [].slice.call(root.querySelectorAll('.hdots b'));
    if(!track){ return; }
    var reales = [].slice.call(track.children);
    var N = reales.length;
    if(N < 2){ return; }
    var timer=null, AUTO=parseInt(root.getAttribute('data-interval'),10)||5500;

    var clonFinal  = reales[0].cloneNode(true);
    var clonInicio = reales[N-1].cloneNode(true);
    [clonFinal, clonInicio].forEach(function(c){
      c.setAttribute('aria-hidden','true');
      /* Los clones duplican enlaces: fuera del recorrido de tabulación para no
         obligar a pasar dos veces por el mismo banner con el teclado. */
      c.querySelectorAll('a').forEach(function(a){ a.setAttribute('tabindex','-1'); });
    });
    track.appendChild(clonFinal);
    track.insertBefore(clonInicio, reales[0]);

    var i = 1;              /* el índice 0 es el clon del último */
    var animando = false;

    function colocar(conAnimacion){
      var anima = conAnimacion && !reduce;
      track.style.transition = anima ? '' : 'none';
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      if(!anima){ void track.offsetWidth; track.style.transition=''; }
    }
    function marcar(){
      var real = ((i - 1) % N + N) % N;
      dots.forEach(function(d,k){ d.classList.toggle('on', k === real); });
    }
    function reponer(){
      if(i === N + 1){ i = 1; colocar(false); }
      else if(i === 0){ i = N; colocar(false); }
      animando = false;
    }
    track.addEventListener('transitionend', function(e){
      if(e.target !== track || e.propertyName !== 'transform'){ return; }
      reponer();
    });
    function go(n){
      if(animando){ return; }
      animando = true;
      i = n; colocar(true); marcar();
      /* Sin animación no hay `transitionend` que dispare el reposicionamiento. */
      if(reduce){ reponer(); }
    }
    function next(){ go(i+1); } function prev(){ go(i-1); }
    colocar(false); marcar();
    /* `pausado` es una decisión EXPLÍCITA del usuario: sobrevive al hover, al
       cambio manual de slide y al swipe. Solo el propio botón la revierte. */
    var pausado=false;
    function start(){ if(reduce||pausado) return; stop(); timer=setInterval(next,AUTO); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    var n=root.querySelector('[data-next]'), p=root.querySelector('[data-prev]');
    if(n) n.addEventListener('click',function(){ next(); start(); });
    if(p) p.addEventListener('click',function(){ prev(); start(); });
    /* `data-i` es el índice REAL (0..N-1); en la pista hay que sumarle 1 porque
       la posición 0 la ocupa el clon del último. */
    dots.forEach(function(d){ d.addEventListener('click',function(){ go(+d.getAttribute('data-i') + 1); start(); }); });

    var pb=root.querySelector('[data-pause]');
    if(pb){
      pb.addEventListener('click',function(){
        pausado=!pausado;
        if(pausado){ stop(); } else { start(); }
        pb.setAttribute('aria-pressed', pausado ? 'true' : 'false');
        pb.setAttribute('aria-label', pausado ? 'Reanudar rotación' : 'Pausar rotación');
        root.classList.toggle('is-paused', pausado);
      });
    }
    /* El puntero NO detiene la rotación. Pasar el mouse por encima es algo que
       ocurre sin querer —el banner ocupa el ancho completo y el cursor lo cruza
       para llegar a cualquier parte—, así que frenar ahí convertía un gesto
       accidental en una orden. La única forma de pausar es el botón de pausa,
       que es explícito y persiste. */
    var x0=null;
    root.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    root.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>45){ dx<0?next():prev(); start(); } x0=null; });
    start();
  });

  /* La rotación de la barra de confianza vivía acá. Se fue junto con los
     puntitos: en móvil los cuatro ítems ahora se muestran en 2×2 y no hay nada
     que turnar. */

  /* ---------- Countdown (deals) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function(box){
    var hours = parseInt(box.getAttribute('data-countdown'),10)||12;
    var H=box.querySelector('[data-h]'), M=box.querySelector('[data-m]'), S=box.querySelector('[data-s]');
    if(!H||!M||!S) return;
    var end = Date.now() + hours*3600*1000;
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var d = Math.max(0, Math.floor((end-Date.now())/1000));
      H.textContent=pad(Math.floor(d/3600)); M.textContent=pad(Math.floor(d%3600/60)); S.textContent=pad(d%60);
      if(d<=0){ end = Date.now() + hours*3600*1000; }
    }
    tick(); setInterval(tick,1000);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]'); if(!b) return;
    var input=b.parentNode.querySelector('input'); if(!input) return;
    var v=parseInt(input.value,10)||1;
    v += (b.getAttribute('data-qty')==='up'?1:-1);
    if(v<1) v=1;
    input.value=v;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---------- Product variant -> price + availability ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var data = form.querySelector('[data-variants]');
    if(!data) return;
    var variants = JSON.parse(data.textContent);
    var select = form.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-price-now]');
    var addBtn = form.querySelector('[data-add]');
    function update(){
      var id = select ? +select.value : variants[0].id;
      var v = variants.filter(function(x){ return x.id===id; })[0] || variants[0];
      if(v){ priceEls.forEach(function(el){ el.textContent = v.price; }); }
      if(addBtn){
        if(v && v.available){ addBtn.disabled=false; addBtn.querySelector('[data-add-label]').textContent='Agregar al carrito'; }
        else { addBtn.disabled=true; addBtn.querySelector('[data-add-label]').textContent='Agotado'; }
      }
    }
    if(select) select.addEventListener('change',update);
    update();
  });

  /* ============================================================
     CARRITO LATERAL + upsell + envío gratis + re-compra  (2026-09-01)
     Vive dentro de este mismo IIFE para reusar `abrirCajon`/`cerrarCajon`.
     Sin JS todo esto no corre y los formularios postean a /cart como siempre.
     ============================================================ */
  var cd = document.getElementById('cartdrawer');
  var fst = document.getElementById('freeshipToast');

  function cdMoney(cents){ return '$' + Math.round((cents||0)/100).toLocaleString('es-CL'); }
  function cdContents(){ return cd ? cd.querySelector('[data-cart-contents]') : null; }

  /* Contador del header + el "(n)" del encabezado del cajón. */
  function cdSetCount(n){
    document.querySelectorAll('.act-badge').forEach(function(b){
      b.textContent = n; b.style.display = n > 0 ? '' : 'none';
    });
    var t = cd && cd.querySelector('[data-cd-count]');
    if(t){ t.textContent = '(' + n + ')'; }
  }

  /* Vuelve a pedir SOLO la sección del cajón y reemplaza su contenido,
     dejando intacto el <aside> (y por tanto su estado abierto/cerrado). */
  function cdRefresh(){
    return fetch('/?sections=cart-drawer', { headers:{ 'X-Requested-With':'fetch' } })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var raw = data['cart-drawer']; if(!raw) return;
        var doc = new DOMParser().parseFromString(raw, 'text/html');
        var fresh = doc.querySelector('#cartdrawer [data-cart-contents]');
        var live = cdContents();
        if(fresh && live){ live.replaceWith(fresh); }
        var ft = doc.querySelector('#freeshipToast');
        if(ft && fst){ fst.setAttribute('data-freeship-min', ft.getAttribute('data-freeship-min')); }
      })
      .catch(function(){});
  }

  /* Globo que SUBE en la pantalla normal al agregar (no abre el cajón). */
  var fstTimer = null;
  function cdFreeToast(total){
    if(!fst) return;
    if(fst.getAttribute('data-freeship-on') !== '1') return;   /* apagado: sin tarifa real de envío gratis */
    var min = parseInt(fst.getAttribute('data-freeship-min'), 10) || 0;
    if(!min) return;
    var msg = fst.querySelector('[data-fst-msg]');
    var bar = fst.querySelector('.fst-bar i');
    var falta = min - total;
    if(falta > 0){
      if(msg) msg.innerHTML = 'Te faltan <b>' + cdMoney(falta) + '</b> para $3.000 de descuento en tu envío';
      if(bar) bar.style.width = Math.min(100, total * 100 / min) + '%';
    } else {
      if(msg) msg.textContent = '¡Ganaste $3.000 de descuento en tu envío!';
      if(bar) bar.style.width = '100%';
    }
    fst.hidden = false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ fst.classList.add('on'); }); });
    clearTimeout(fstTimer);
    fstTimer = setTimeout(function(){
      fst.classList.remove('on');
      setTimeout(function(){ fst.hidden = true; }, 420);
    }, 4200);
  }

  /* Resalta la primera sugerencia del cajón un momento tras un "agregar". */
  function cdHotUpsell(){
    var first = cd && cd.querySelector('[data-upsell] .up-card');
    if(!first) return;
    first.classList.add('is-hot');
    setTimeout(function(){ first.classList.remove('is-hot'); }, 3200);
  }

  function cdOpen(){ if(cd){ abrirCajon(cd); } }
  function cdKeepOpen(){
    if(!cd) return;
    cd.classList.add('on');
    cd.removeAttribute('aria-hidden');
    if(scrim) scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
    abierto = cd;
  }

  /* --- Agregar al carro por AJAX: cards, PDP y upsell --- */
  function cdAjaxAdd(form){
    var btn = form.querySelector('[type="submit"]');
    if(btn){ btn.classList.add('is-loading'); btn.disabled = true; }
    return fetch('/cart/add.js', { method:'POST', body: new FormData(form), headers:{ 'X-Requested-With':'fetch' } })
      .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        cdSetCount(cart.item_count);
        return cdRefresh().then(function(){
          cdOpen();
          cdHotUpsell();
          cdFreeToast(cart.total_price);
        });
      })
      .catch(function(){ if(btn){ btn.disabled = false; } form.submit(); })
      .then(function(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  if(cd){
    document.addEventListener('submit', function(e){
      var form = e.target.closest('[data-quickadd]');
      if(!form) return;
      e.preventDefault();
      cdAjaxAdd(form);
    }, true);

    /* Al abrir el cajón desde el header, refrescar por si el carro cambió en otra pestaña. */
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-cart-link]')){ cdRefresh(); }
    });

    /* Cantidad y quitar DENTRO del cajón → /cart/change.js (atributos propios,
       distintos de los steppers [data-qty] para no doblar el manejo). */
    var cdBusy = false;
    function cdChange(line, qty){
      if(cdBusy) return;
      cdBusy = true;
      fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'X-Requested-With':'fetch' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function(r){ return r.json(); })
        .then(function(cart){ cdSetCount(cart.item_count); return cdRefresh(); })
        .then(function(){ cdKeepOpen(); })
        .catch(function(){})
        .then(function(){ cdBusy = false; });
    }
    document.addEventListener('click', function(e){
      var q = e.target.closest('[data-cd-qty]');
      if(q){
        var row = q.closest('[data-line]');
        var line = parseInt(row.getAttribute('data-line'), 10);
        var cur = parseInt(row.querySelector('[data-cd-q]').textContent, 10) || 1;
        cdChange(line, q.getAttribute('data-cd-qty') === 'up' ? cur + 1 : Math.max(0, cur - 1));
        return;
      }
      var rm = e.target.closest('[data-cd-remove]');
      if(rm){
        e.preventDefault();
        e.stopPropagation();
        cdChange(parseInt(rm.getAttribute('data-line'), 10), 0);
      }
    });

    /* Volver a comprar (A13): data-reorder="variantId:qty,variantId:qty" */
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-reorder]');
      if(!b) return;
      e.preventDefault();
      var items = b.getAttribute('data-reorder').split(',').map(function(p){
        var kv = p.split(':');
        return { id: parseInt(kv[0], 10), quantity: parseInt(kv[1], 10) || 1 };
      }).filter(function(x){ return x.id; });
      if(!items.length) return;
      b.classList.add('is-loading'); b.disabled = true;
      fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'X-Requested-With':'fetch' },
        body: JSON.stringify({ items: items })
      })
        .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
        .then(function(cart){ cdSetCount(cart.item_count); return cdRefresh(); })
        .then(function(){ cdOpen(); })
        .catch(function(){})
        .then(function(){ b.classList.remove('is-loading'); b.disabled = false; });
    });

    /* Recordatorio de carrito (A15): una vez por sesión, si quedó algo dentro. */
    try{
      if(!sessionStorage.getItem('tb_cartnudge')){
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          if(cart.item_count > 0 && fst){
            sessionStorage.setItem('tb_cartnudge', '1');
            var msg = fst.querySelector('[data-fst-msg]');
            if(msg){ msg.innerHTML = 'Dejaste <b>' + cart.item_count + '</b> producto' + (cart.item_count > 1 ? 's' : '') + ' en el carrito · <a href="#" data-cart-link>Ver</a>'; }
            fst.hidden = false;
            requestAnimationFrame(function(){ requestAnimationFrame(function(){ fst.classList.add('on'); }); });
            setTimeout(function(){ fst.classList.remove('on'); setTimeout(function(){ fst.hidden = true; }, 420); }, 6000);
          }
        }).catch(function(){});
      }
    }catch(e){}
  }

  /* ---------- Favoritos (localStorage, sin backend) ---------- */
  var FAV_KEY='tb_favs';
  function favRead(){ try{ return JSON.parse(localStorage.getItem(FAV_KEY)||'[]'); }catch(e){ return []; } }
  function favWrite(list){ try{ localStorage.setItem(FAV_KEY, JSON.stringify(list)); }catch(e){} }
  function favHas(list,h){ return list.some(function(x){ return x.handle===h; }); }
  function favCount(){ var n=favRead().length; document.querySelectorAll('[data-fav-count]').forEach(function(el){ el.textContent=n; }); }
  function favMark(){ var list=favRead(); document.querySelectorAll('[data-fav]').forEach(function(b){ b.classList.toggle('on', favHas(list,b.getAttribute('data-fav-handle'))); }); }

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-fav]'); if(!b) return;
    e.preventDefault();
    var h=b.getAttribute('data-fav-handle');
    var list=favRead();
    if(favHas(list,h)){
      list=list.filter(function(x){ return x.handle!==h; });
    } else {
      list.push({ handle:h, title:b.getAttribute('data-fav-title'), url:b.getAttribute('data-fav-url'),
        price:b.getAttribute('data-fav-price'), icon:b.getAttribute('data-fav-icon'),
        bg:b.getAttribute('data-fav-bg'), ic:b.getAttribute('data-fav-ic'), img:b.getAttribute('data-fav-img')||'' });
      b.animate([{transform:'scale(1)'},{transform:'scale(1.3)'},{transform:'scale(1)'}],{duration:260});
    }
    favWrite(list); favMark(); favCount(); renderFavs();
  });

  function renderFavs(){
    var grid=document.querySelector('[data-favs-grid]'); if(!grid) return;
    var empty=document.querySelector('[data-favs-empty]');
    var list=favRead();
    if(!list.length){ grid.style.display='none'; if(empty) empty.style.display='block'; return; }
    if(empty) empty.style.display='none'; grid.style.display='';
    var heartSVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg>';
    grid.innerHTML=list.map(function(f){
      var media = f.img ? '<img src="'+f.img+'" alt="'+f.title+'">' : '<span class="gico">'+iconSvg(f.icon)+'</span>';
      return '<article class="pcard">'+
        '<button class="pwish on" type="button" data-fav data-fav-handle="'+f.handle+'" aria-label="Quitar de favoritos">'+heartSVG+'</button>'+
        '<a class="pthumb" href="'+f.url+'" style="--ptint:'+f.bg+';--picon:'+f.ic+'">'+media+'</a>'+
        '<div class="pbody"><a href="'+f.url+'"><h4 class="ptitle">'+f.title+'</h4></a>'+
        '<div class="pprice"><span class="now tnum">'+f.price+'</span></div>'+
        '<a class="padd" href="'+f.url+'">Ver producto</a></div></article>';
    }).join('');
  }
  function iconSvg(name){
    var p={ cable:'<path d="M4 9a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3"/><path d="M7 3v3M5 6h4"/><rect x="15" y="15" width="6" height="6" rx="1"/>',
      bolt:'<path d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z"/>', headphones:'<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a9 9 0 0 1 18 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>',
      grid:'<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>' };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'+(p[name]||p.grid)+'</svg>';
  }

  favMark(); favCount(); renderFavs();

  /* ============================================================
     VISTOS RECIENTEMENTE (A13) — historial en localStorage `tb_recent`.
     La ficha de producto empuja acá; el home y la propia ficha lo pintan.
     ============================================================ */
  var RECENT_KEY = 'tb_recent';
  function recentRead(){ try{ var list=JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(list)?list:[]; }catch(e){ return []; } }
  function recentPush(item){
    if(!item || !item.handle) return;
    var list = recentRead().filter(function(x){ return x.handle !== item.handle; });
    list.unshift(item);
    list = list.slice(0, 12);
    try{ localStorage.setItem(RECENT_KEY, JSON.stringify(list)); }catch(e){}
  }
  /* La ficha deja `window.__tbRecent = {...}` antes de cargar este script. */
  if(window.__tbRecent){ recentPush(window.__tbRecent); }

  document.querySelectorAll('[data-recent-section]').forEach(async function(sec){
    var grid = sec.querySelector('[data-recent-grid]');
    var here = (window.__tbRecent && window.__tbRecent.handle) || '';
    var history = recentRead();
    var handles = Array.isArray(history) ? Array.from(new Set(history.filter(function(x){return x && typeof x.handle === 'string' && /^[a-z0-9-]+$/.test(x.handle) && x.handle !== here;}).map(function(x){return x.handle;}))).slice(0,12) : [];
    if(!grid || !handles.length) return;
    sec.hidden = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cards = await Promise.all(handles.map(async function(handle){
      try{
        var response = await fetch(root+'products/'+encodeURIComponent(handle)+'?section_id=tb-home-product-card',{signal:AbortSignal.timeout(8000)});
        if(!response.ok) return null;
        var doc = new DOMParser().parseFromString(await response.text(),'text/html');
        var safe = doc.querySelector('[data-home-safe-product]');
        if(!safe || safe.getAttribute('data-home-safe-product') !== handle) return null;
        return safe.querySelector('.pcard');
      }catch(error){return null;}
    }));
    var fragment = document.createDocumentFragment();
    cards.filter(Boolean).slice(0,10).forEach(function(card){fragment.appendChild(document.importNode(card,true));});
    grid.replaceChildren(fragment);
    sec.hidden = !grid.children.length;
    favMark();
  });


  /* ============================================================
     POPUP DE EMAIL / RULETA (A9 + B5) — `snippets/email-pop.liquid`
     ============================================================ */
  (function(){
    var pop = document.getElementById('emailPop');
    if(!pop) return;
    var POP_KEY = 'tb_pop';
    var CLAIM_KEY = 'tb_welcome_claimed';
    var path = location.pathname;
    var subscribed = !!pop.querySelector('[data-epop-subscribed]');
    if(/\/(checkout|cart)(\/|$)/.test(path)) return;
    if(document.getElementById('tb-age-gate')) return;      /* página +18: no encimar */
    if(!subscribed){
      try{
        if(localStorage.getItem(CLAIM_KEY) === '1') return;
        var last = parseInt(localStorage.getItem(POP_KEY) || '0', 10);
        if(last && (Date.now() - last) < 30 * 864e5) return; /* "Ahora no": pausa 30 días */
      }catch(e){}
    }

    var shown = false;
    function suppress(){ try{ localStorage.setItem(POP_KEY, String(Date.now())); }catch(e){} }
    function open(){
      if(shown) return;
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(function(){ pop.classList.add('on'); });
      document.body.style.overflow = 'hidden';
    }
    function close(){
      pop.classList.remove('on');
      document.body.style.overflow = '';
      setTimeout(function(){ pop.hidden = true; }, 300);
      suppress();
    }

    /* Tras confirmar el correo, vuelve abierto directamente al giro. */
    if(subscribed){
      open();
    } else {
      /* disparadores */
      var mobile = window.matchMedia('(max-width:900px)').matches;
      if(mobile){
        setTimeout(open, 10000);
        var onScroll = function(){
          var h = document.documentElement;
          if((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.32){ open(); window.removeEventListener('scroll', onScroll); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        document.addEventListener('mouseout', function(e){
          if(!e.relatedTarget && e.clientY <= 0){ open(); }
        });
        setTimeout(open, 14000); /* respaldo si nunca sale del viewport */
      }
    }

    pop.addEventListener('click', function(e){
      if(e.target.closest('[data-epop-close]')){ close(); return; }

      if(e.target.closest('[data-epop-spin]')){
        var wheel = pop.querySelector('[data-epop-wheel]');
        var spinBtn = e.target.closest('[data-epop-spin]');
        spinBtn.disabled = true;
        var turns = 1440 + Math.floor(Math.random() * 360);
        if(wheel){
          wheel.style.transition = reduce ? 'none' : 'transform 3.4s cubic-bezier(.17,.67,.28,1)';
          wheel.style.transform = 'rotate(' + turns + 'deg)';
        }
        var reveal = function(){
          pop.querySelector('[data-epop-stage="wheel"]').hidden = true;
          pop.querySelector('[data-epop-stage="prize"]').hidden = false;
          try{
            localStorage.setItem('tb_welcome_discount', 'BIENVENIDA10');
            localStorage.setItem(CLAIM_KEY, '1');
          }catch(e){}
        };
        if(reduce){ reveal(); } else { setTimeout(reveal, 3500); }
      }

      if(e.target.closest('[data-epop-copy]')){
        var code = (pop.querySelector('[data-epop-code]') || {}).textContent || '';
        var btn = e.target.closest('[data-epop-copy]');
        if(navigator.clipboard){ navigator.clipboard.writeText(code.trim()).then(function(){ btn.textContent = '¡Copiado!'; }); }
      }
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && pop.classList.contains('on')){ close(); } });

  })();

  /* El premio de la ruleta viaja al checkout con el endpoint nativo de Shopify.
     Shopify valida el código real; aquí solo se recuerda que esta persona lo ganó. */
  function tbWelcomeCheckout(){
    var code = '';
    try{ code = localStorage.getItem('tb_welcome_discount') || ''; }catch(e){}
    if(!/^[A-Z0-9_-]{3,64}$/.test(code)) return false;
    window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/checkout');
    return true;
  }
  document.addEventListener('click', function(e){
    var checkout = e.target.closest('[data-welcome-checkout]');
    if(!checkout) return;
    if(tbWelcomeCheckout()) e.preventDefault();
  });
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-cart-form]');
    var submitter = e.submitter;
    if(!form || !submitter || !submitter.name || submitter.name !== 'checkout') return;
    if(tbWelcomeCheckout()) e.preventDefault();
  });

  /* ---------- Barra de anuncio: rotación de mensajes ---------- */
  document.querySelectorAll('[data-ann-rot]').forEach(function(rot){
    var msgs = rot.querySelectorAll('.ann-msg');
    if(msgs.length < 2) return;
    var i = 0;
    setInterval(function(){
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4200);
  });

  /* ---------- Código que ya no tiene a quién animar ----------
     De acá salieron cuatro bloques —~110 líneas que el navegador seguía
     descargando, parseando y ejecutando en cada visita para nada:

     · CountUp (`[data-count]`) — no queda un solo elemento con ese atributo.
     · Spotlight que seguía el cursor (`.catgrid`) — la grilla de categorías se
       reemplazó por el rail.
     · Partículas en canvas (`[data-particles]`) — el canvas se sacó de la banda
       de tiendas. Corría un doble for sobre hasta 220 puntos por frame.
     · Scroll reveal (`.reveal`) — el movimiento quedó reservado a lo que el
       dedo toca.

     Los tres últimos solo los usaban `sections/category-grid.liquid` y
     `sections/duo-feature.liquid`, que ya no están en templates/index.json.
     OJO: esos dos archivos siguen en /sections. No se pintan, pero el editor de
     temas todavía los ofrece para agregar a mano — si algún día reaparecen en
     la home, van sin animación, que es justamente la intención. */

})();
